import * as Yup from 'yup';
import { Form, Col, Row } from 'react-bootstrap';
import LocalizedStrings from 'react-localization';
import { Options } from '../SelectOptions';
import { CustomFormSelect, CustomFormControl } from '../../../../StyledComponents';
import { ClientLanguage, getClientLanguageAsString } from "../../../../../Api"

let locStrings = new LocalizedStrings({
    de:
    {
        becomingAwareThrough: "Wie bist du auf uns aufmerksam geworden?*",
        becomingAwareThroughPlaceholder: "Bitte auswählen...",
        becomingAwareThroughRequired: "Angabe ist erforderlich",
        becomingAwareThroughOtherValue: "Sonstiges",
        becomingAwareThroughOtherPlaceholder: "Bitte eingeben, wie du auf uns aufmerksam geworden bist",
    },
    en:
    {
        becomingAwareThrough: "How did you find us?*",
        becomingAwareThroughPlaceholder: "Please select...",
        becomingAwareThroughRequired: "Information required",
        becomingAwareThroughOtherValue: "Sonstiges",  // value, not text
        becomingAwareThroughOtherPlaceholder: "Please enter how you found us.",
    }
});

function setLanguage(clientLanguage): void {
    switch(clientLanguage) { 
        case ClientLanguage.German: { 
           locStrings.setLanguage('de');
           break; 
        } 
        case ClientLanguage.English: { 
           locStrings.setLanguage('en'); 
           break; 
        } 
        // Otherwise "clientLanguage" is "ClientLanguage.BrowserSetting" and language used is browser setting dependent.
    } 
}

export const Schema = (clientLanguage) => Yup.object().shape({
    becomingAwareThrough: Yup.string()
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema.required(locStrings.becomingAwareThroughRequired);
              },
        }),
    becomingAwareThroughOther: Yup.string()
        .when("InformationIsRequired", {
            is: () => true,
            then: (schema) => {
                setLanguage(clientLanguage);
                return schema
                    .when('becomingAwareThrough', {
                        is: locStrings.becomingAwareThroughOtherValue,
                        then: Yup.string().required(locStrings.becomingAwareThroughRequired),
                    });
            },
        }),
});

export const OtherInformationSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings, clientLanguage } = props;

    setLanguage(clientLanguage);

    function getClientLanguage(): string { 
        return getClientLanguageAsString(clientLanguage); 
    } 
    
    return (
        <>
            <Row className="mb-3">
                {values.becomingAwareThrough !== locStrings.becomingAwareThroughOtherValue && <Form.Group className="mb-3" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>{locStrings.becomingAwareThrough}</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">{locStrings.becomingAwareThroughPlaceholder}</option>
                        {clientLanguage == ClientLanguage.English ?
                        Options.BecomingAwareThroughPermanentEmployeesEnglish.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        :Options.BecomingAwareThroughPermanentEmployeesGerman.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        }
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === locStrings.becomingAwareThroughOtherValue && <Form.Group className="mb-2" as={Col} controlId="formBecomingAwareThrough">
                    <Form.Label>{locStrings.becomingAwareThrough}</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="becomingAwareThrough"
                        value={values.becomingAwareThrough}
                        isValid={touched.becomingAwareThrough && !errors.becomingAwareThrough}
                        isInvalid={touched.becomingAwareThrough && errors.becomingAwareThrough}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">{locStrings.becomingAwareThroughPlaceholder}</option>
                        {clientLanguage == ClientLanguage.English ?
                        Options.BecomingAwareThroughPermanentEmployeesEnglish.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        :Options.BecomingAwareThroughPermanentEmployeesGerman.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)
                        }
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThrough}
                    </Form.Control.Feedback>
                </Form.Group>}
                {values.becomingAwareThrough === locStrings.becomingAwareThroughOtherValue && <Form.Group className="mb-3" controlId="formBecomingAwareThroughOther">
                    <CustomFormControl
                        colors={colors}
                        placeholder={locStrings.becomingAwareThroughOtherPlaceholder}
                        type="text"
                        name="becomingAwareThroughOther"
                        value={values.becomingAwareThroughOther}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.becomingAwareThroughOther && !errors.becomingAwareThroughOther}
                        isInvalid={touched.becomingAwareThroughOther && errors.becomingAwareThroughOther}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.becomingAwareThroughOther}
                    </Form.Control.Feedback>
                </Form.Group>}
            </Row>
        </>
    );
};